module.exports = __webpack_public_path__ + "img/ios-preview-frame.cd4a859.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ios-preview-frame.png
// module id = qaHg
// module chunks = 38 43